/**
 * Removes all attachments of a correlation.
 *
 * @param {Correlation} correlation
 */
export function removeAttachments(correlation) {
    correlation.attachment = {};
    return correlation;
}
//# sourceMappingURL=removeAttachments.js.map